import { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import api from '../api';
import ImageLightbox from '../components/ImageLightbox';

function PageView() {
  const { slug } = useParams();
  const [page, setPage] = useState(null);
  const [loading, setLoading] = useState(true);
  const [lightboxIndex, setLightboxIndex] = useState(null);

  useEffect(() => {
    api.get(`/api/pages/slug/${slug}`)
      .then(res => setPage(res.data))
      .catch(() => setPage(null))
      .finally(() => setLoading(false));
  }, [slug]);

  if (loading) {
    return <div className="loading">A carregar...</div>;
  }

  if (!page) {
    return (
      <div className="container" style={{ paddingTop: '60px', textAlign: 'center' }}>
        <h1>Página não encontrada</h1>
        <Link to="/" className="btn btn-primary" style={{ marginTop: '24px' }}>Voltar ao início</Link>
      </div>
    );
  }

  const images = page.images && page.images.length > 0 ? page.images : [];

  return (
    <div className="container" style={{ paddingTop: '48px', paddingBottom: '72px' }}>
      <Link to="/" style={{ color: 'var(--text-secondary)', marginBottom: '24px', display: 'inline-block', fontSize: '0.88rem', letterSpacing: '0.03em' }}>
        ← Voltar ao início
      </Link>

      <h1 style={{ marginBottom: '12px', fontSize: '2.2rem' }}>{page.heading}</h1>
      <hr style={{ width: '50px', height: '2px', background: 'var(--accent)', border: 'none', marginBottom: '36px' }} />

      {(page.body && page.body.trim()) ? (
        <div
          style={{
            color: 'var(--text-secondary)',
            lineHeight: '1.85',
            marginBottom: '48px',
            whiteSpace: 'pre-wrap',
            maxWidth: '720px',
            fontSize: '1rem',
            fontWeight: 300
          }}
        >
          {page.body.split('\n').map((p, i) => (
            <p key={i} style={{ marginBottom: '1rem' }}>{p}</p>
          ))}
        </div>
      ) : (
        <p style={{ color: 'var(--text-secondary)', marginBottom: '48px', fontStyle: 'italic' }}>
          Conteúdo em atualização. Volte em breve.
        </p>
      )}

      {images.length > 0 && (
        <div style={{ marginBottom: '48px' }}>
          <h2 style={{ marginBottom: '20px', fontSize: '1.3rem', fontWeight: 500 }}>Fotografias</h2>
          <div className="image-grid">
            {images.map((src, index) => (
              <button
                key={index}
                type="button"
                className="image-grid-item"
                onClick={() => setLightboxIndex(index)}
                aria-label={`Ver imagem ${index + 1}`}
              >
                <img src={src} alt="" />
              </button>
            ))}
          </div>
        </div>
      )}

      {page.catalog_pdf && (
        <div style={{
          padding: '32px',
          backgroundColor: 'var(--background-secondary)',
          borderRadius: 'var(--radius-lg, 14px)',
          textAlign: 'center',
          border: '1px solid var(--border, rgba(255,255,255,0.06))'
        }}>
          <p style={{ marginBottom: '16px', color: 'var(--text-secondary)', fontSize: '0.95rem' }}>
            Consulte o nosso catálogo
          </p>
          <Link
            to={`/view-catalog/${page.slug}`}
            className="btn btn-primary"
          >
            Abrir catálogo
          </Link>
        </div>
      )}

      {lightboxIndex !== null && (
        <ImageLightbox
          images={images}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onNavigate={(delta) => setLightboxIndex(prev => prev + delta)}
        />
      )}
    </div>
  );
}

export default PageView;
